import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ButtonIconSet, SecondaryButtonIconType } from '../buttons.types';

@Component({
  selector: 'common-secondary-buttons-filled',
  templateUrl: './secondary-button-filled.component.html',
  styleUrls: ['./secondary-button-filled.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SecondaryButtonsFilledComponent implements OnInit {
  private readonly defaultIconSet = 'material-symbols-rounded';

  @Input() label: string;
  @Input() icon: string;
  @Input() disabled: boolean = false;
  @Input() typeIcon: SecondaryButtonIconType = 'outlined'
  @Input() iconSet: ButtonIconSet;
  @Input() iconPosition: boolean = true;

  @Output() output: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor() { }

  ngOnInit(): void { }

  get iconClass(): string {
    if (this.iconSet) {
      return this.iconSet;
    }

    if (this.typeIcon === 'outlined') {
      return 'material-icons-outlined';
    }

    if (this.typeIcon === 'rounde') {
      return 'material-symbols-rounded';
    }

    return this.defaultIconSet;
  }

  onClick() {
    this.output.emit(true);
  }
}
